import { useState, useEffect } from 'react';
import axiosInstance from '../utils/axiosInstance';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Box, Stack, List, ListItemButton, ListItemIcon, ListItemText, Divider, Typography, Link } from '@mui/material';
import { Sort, Mail, Home, Apartment, Settings, ReceiptLong, ShoppingCart } from '@mui/icons-material';

export const menuItems = [
  { to: '/cart', icon: ShoppingCart, label: 'カート' },
  { to: '/orders', icon: ReceiptLong, label: '注文履歴' },
  { to: '/contact', icon: Mail, label: 'お問合わせ' },
  { to: '/company', icon: Apartment, label: '会社概要' },
  { to: '/clients/detail', icon: Settings, label: '会員情報の変更' },
];

const Sidebar = ({ onItemClick }) => {
  const location = useLocation();
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const loadCategories = async () => {
      try {
        const res = await axiosInstance.get('/category/list-with-products?parentOnly=true');
        setCategories(res.data || []);
      } catch (err) {
        if (err.response?.status === 404) { return; }
        console.error('カテゴリー情報の取得に失敗:', err);
        setCategories([]);
      }
    };

    loadCategories();
  }, []);

  return (
    <>
      <List dense sx={{ px: 1, }}>
        <ListItemButton
          key='/'
          component={Link}
          to='/'
          selected={location.pathname === '/'}
          onClick={onItemClick}
          sx={{
            borderRadius: 1,
            '&:hover': {
              bgcolor: 'action.hover',
            },
          }}
        >
          <ListItemIcon sx={{ minWidth: 36 }}>
            <Home fontSize="small" />
          </ListItemIcon>

          <ListItemText
            primary='サイトトップ'
          />
        </ListItemButton>
      </List>

      {/* カテゴリー */}
      <Box sx={{ px: 1, pt: 1, bgcolor: 'background.secondary' }} >
        <Stack direction="row" alignItems="center" spacing={0.5}>
          <Sort fontSize="small" color="text.secondary" />
          <Typography variant="caption" color="text.secondary">
            カテゴリーから探す
          </Typography>
        </Stack>
        <List dense>
          {(categories || []).map(cat => (
            <ListItemButton
              key={cat.category_id}
              component={Link}
              to={`/category/${cat.category_id}`}
              onClick={onItemClick}
            >
              <ListItemText primary={cat.category_name} />
            </ListItemButton>
          ))}
        </List>
      </Box>

      {/* メニュー */}
      <List dense sx={{ px: 1 }}>{menuItems.map(({ to, icon: Icon, label }) => (
        <ListItemButton
          key={to}
          component={Link}
          to={to}
          selected={location.pathname === to}
          onClick={onItemClick}
          sx={{
            borderRadius: 1,
            '&:hover': {
              bgcolor: 'action.hover',
            },
          }}
        >
          <ListItemIcon sx={{ minWidth: 36 }}>
            <Icon fontSize="small" />
          </ListItemIcon>

          <ListItemText
            primary={label}
          />
        </ListItemButton>
      ))}
      </List>
    </>
  );
};

export default Sidebar;
